import { ReportingConfigT } from './types';

export type { ReportingConfigT } from './types';

const isNode = process.versions && process.versions.node;

const injectedVars = isNode ? process.env : window.__OG_REPORTING_GLOBAL_ENV_VARIABLES__;

export const ReportingConfig: ReportingConfigT = {
  GOOGLE_ANALYTICS_PROPERTY_ID: injectedVars.GOOGLE_ANALYTICS_PROPERTY_ID,
  OPERATE_URL: injectedVars.OPERATE_API_HOST,
  OPERATE_API_HOST: injectedVars.OPERATE_API_HOST,
  PLATFORM_API_HOST: injectedVars.PLATFORM_API_HOST,
  PUBLIC_REPORTS_API_HOST: injectedVars.PUBLIC_REPORTS_API_HOST ?? '',
  EMBED_BUNDLE_URL: injectedVars.EMBED_BUNDLE_URL,
  STORIES_URL: injectedVars.STORIES_URL,
  MODULE_STYLES_URL: injectedVars.MODULE_STYLES_URL,
  WALK_ME_URL: injectedVars.WALK_ME_URL,
  LAUNCH_DARKLY_ENV_KEY: injectedVars.LAUNCH_DARKLY_ENV_KEY,
  GOOGLE_API_CLIENT_ID: injectedVars.GOOGLE_API_CLIENT_ID,
  SEGMENT_ANALYTICS_ID: injectedVars.SEGMENT_ANALYTICS_ID,
  NEW_RELIC_APP_ID: injectedVars.NEW_RELIC_APP_ID,
  FARO_COLLECTOR_URL: injectedVars.FARO_COLLECTOR_URL,
  AUTH0_CLIENT_ID: injectedVars.AUTH0_CLIENT_ID,
  AUTH0_DOMAIN: injectedVars.AUTH0_DOMAIN,
  CLOUDFRONT_URL: injectedVars.CLOUDFRONT_URL,
  SF_INTEGRATION_KEY: injectedVars.SF_INTEGRATION_KEY,
  SF_PLATFORM_NAME: injectedVars.SF_PLATFORM_NAME,
  SF_MESSAGE_ID: injectedVars.SF_MESSAGE_ID,
  SF_SECRET_URL: injectedVars.SF_SECRET_URL,
  GITHUB_SHA: injectedVars.GITHUB_SHA,
  IS_PSP_BUILD: injectedVars.IS_PSP_BUILD === 'true',
  ERP_API_HOST: injectedVars.ERP_API_HOST,
  OG_AGENTS_BASE_URL: injectedVars.OG_AGENTS_BASE_URL
};
